import { render, staticRenderFns } from "./cmpLoading.vue?vue&type=template&id=3280e881&"
import script from "./cmpLoading.vue?vue&type=script&lang=js&"
export * from "./cmpLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports